/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".pc-reservation-modal .modal-content{border-radius:20px;overflow:hidden}.pc-reservation-modal lp2-pc-reservation-iframe{display:block;position:relative}.pc-reservation-modal .pc-reservation-frame{display:block;height:600px;max-height:80vh}.pc-reservation-modal .pc-reservation-close{position:absolute;top:16px;right:20px;z-index:2;font-size:22px;line-height:1}.pc-reservation-modal .pc-reservation-close .fa-times,.pc-reservation-modal .pc-reservation-close button{color:#0080ff}"];
export { styles as styles };
//# sourceMappingURL=pc-reservation-iframe.component.scss.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/live-class-revamp/pc-reservation-iframe/pc-reservation-iframe.component.scss.ngstyle.js
// module id = 1346
// module chunks = 27 28 29